'use client'

import { useState, useEffect, useCallback } from "react"
import { Artist } from '@/types'
import { throttle } from "@/utils"
import { FetchArtists } from "@/api"
export default function theme(props) {
  const [artists, setArtists] = useState<Artist[]>(props.artists)
  const [pageNum, setPageNum] = useState(1)
  const [hasNext, setHasNext] = useState(props.hasNext)
  const [loading, setLoading] = useState(false)

  const loadMoreArtists = useCallback(async () => {
    if (!hasNext || loading) return

    setLoading(true)

    try {
      const response = await FetchArtists(props.apiHost, {
        pageSize: 10,
        pageNum: pageNum,
      })
      const { singerInfoList, hasNext } = response

      setArtists((prev) => [...prev, ...singerInfoList])
      setHasNext(hasNext)
      setPageNum(prev => prev + 1)
    } finally {
      setLoading(false)
    }
  }, [pageNum, hasNext, loading])

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement

      if (scrollTop + clientHeight >= scrollHeight - 400) {
        loadMoreArtists()
      }
    }

    const throttledScroll = throttle(handleScroll, 100)

    window.addEventListener('scroll', throttledScroll)

    return () => window.removeEventListener('scroll', throttledScroll)
  }, [loadMoreArtists])

  useEffect(() => {
    loadMoreArtists()
  }, [])

  return artists?.length ? <section>
    <ul className="flex flex-col gap-6 p-6">
      {artists.map((item: Artist) => (
        <li className="flex flex-row justify-between" key={item?.id}>
          <a
            className="flex flex-row flex-1 text-left"
            href={`/artist/${item?.id}`}
            title={item?.singerName}
          >
            <article className="flex justify-center overflow-hidden border border-slate-50/5 rounded-full w-14 h-14">
              <img
                className="w-full h-fit"
                src={item.singerImgUrl || '/logo.png'}
                alt={item?.singerName}
              />
            </article>
            <article className="ml-4 flex flex-col justify-center gap-1">
              <h3 className="text-[15px] font-bold max-w-40 xs:max-w-48 sm:max-w-56 md:max-w-72 lg:max-w-96 truncate">
                {item?.singerName}
              </h3>
              <h6 className="text-[13px] font-normal opacity-50 max-w-40 xs:max-w-48 sm:max-w-56 md:max-w-72 lg:max-w-96 truncate">
                {item?.albumList?.length ? item?.albumList.join(', ') : null}
              </h6>
            </article>
          </a>
          <a className="flex flex-col justify-center items-center flex-none w-4" href={`/artist/${item?.id}`}>
            <img src="/svg/arrow-right.svg" alt="Go to detail" className="w-[6px] h-[11px]" />
          </a>
        </li>
      ))}
    </ul>
    {loading && <article className="flex justify-center items-center p-5 pt-0">loading...</article>}
  </section> : null
}